import { LocaleCode } from "../../typings/lang";

export class SelectLanguageController {
    public static $inject: string[] = ["$scope", "$translate"];

    // binded
    public languages: LocaleCode[];
    public selectedLanguage: LocaleCode;
    public sourceLang: LocaleCode;

    private $t;

    constructor($scope, $translate: ng.translate.ITranslateService) {
        this.$t = $translate.instant;

        $scope.localeSort = (a, b) => {
            // If we don't get strings, just compare by index
            if (a.type !== "string" || b.type !== "string") {
                return a.index < b.index ? -1 : 1;
            }
            // Compare strings alphabetically, taking locale into account
            return this.$t(`lang.${a.value.toLowerCase()}`).localeCompare(this.$t(`lang.${b.value.toLowerCase()}`));
        };
    }
}
